export function checkoutBrowserType() {
  const appBrowserType = window.App?.browserType || window.App?.browser_type
  if (typeof appBrowserType === "string" && appBrowserType.trim().length > 0) {
    return appBrowserType.trim().toLowerCase()
  }

  const userAgent = window.navigator?.userAgent || ""
  if (userAgent.includes("Edg/")) return "edge"
  if (userAgent.includes("Firefox/")) return "firefox"
  if (userAgent.includes("Chrome/")) return "chrome"
  if (userAgent.includes("Safari/") && !userAgent.includes("Chrome/")) return "safari"

  return "unknown"
}

export function buildCheckoutRumContext({
  paymentElementLayout,
  expressCheckoutPlacement,
  expressWalletPaymentMethodsMode,
  restrictToCardOnly,
  setupIntentSource,
  checkoutAbVariants,
}) {
  return {
    browser_type: checkoutBrowserType(),
    payment_element_layout: paymentElementLayout,
    express_checkout_placement: expressCheckoutPlacement,
    express_wallet_mode: expressWalletPaymentMethodsMode,
    restrict_to_card_only: restrictToCardOnly,
    setup_intent_source: setupIntentSource,
    ...(checkoutAbVariants?.wallet ? { ab_wallet: checkoutAbVariants.wallet } : {}),
    ...(checkoutAbVariants?.payment ? { ab_payment: checkoutAbVariants.payment } : {}),
    ...(checkoutAbVariants?.layout ? { ab_layout: checkoutAbVariants.layout } : {}),
    ...(checkoutAbVariants?.pricing ? { ab_pricing: checkoutAbVariants.pricing } : {}),
    ...(checkoutAbVariants?.express ? { ab_express: checkoutAbVariants.express } : {}),
  }
}
